import { User } from "models";
import qs from "query-string";
import { api, providesList } from ".";

const url = "/users";

const userAPI = api.injectEndpoints({
	endpoints: (build) => ({
		getUsers: build.query<User[], Record<string, any> | undefined>({
			query: (query) => {
				if (query) {
					return `${url}?${qs.stringify(query)}`;
				}
				return url;
			},
			providesTags: (result) => providesList(result, "users"),
		}),
		createUsers: build.mutation<void, Record<string, any>>({
			query: (data) => {
				return {
					url,
					method: "POST",
					body: data,
				};
			},
			invalidatesTags: (result, error, { id }) => {
				return error ? [] : [{ type: "users", id }];
			},
		}),
		updateUsers: build.mutation<void, Record<string, any>>({
			query: (data) => {
				return {
					url: `${url}/${data}`,
					method: "PUT",
					body: "",
				};
			},
			invalidatesTags: (result, error, { id }) => {
				return error ? [] : [{ type: "users", id }];
			},
		}),
		editEmailUser: build.mutation<void, { id: string; email: string }>({
			query: (body) => {
				const { id, ...rest } = body;
				return {
					url: `${url}/${id}/edit-email`,
					method: "PUT",
					body: rest,
				};
			},
			invalidatesTags: (result, error, { id }) => {
				return error ? [] : [{ type: "users", id }];
			},
		}),
		deleteUsers: build.mutation<void, number | undefined>({
			query: (id) => {
				return {
					url: `${url}`,
					method: "DELETE",
				};
			},
			invalidatesTags: (result, error) => {
				return error ? [] : [{ type: "users", id: "LIST" }];
			},
		}),
		getUserCount: build.query<{ total: number; notSeen: number; seen: number; completed: number }, void>({
			query: (query) => {
				return `${url}/count`;
			},
			providesTags: [{ type: "users", id: "LIST" }],
		}),
		deleteUserById: build.mutation<void, string>({
			query: (id) => {
				return {
					url: `${url}/${id}`,
					method: "DELETE",
				};
			},
			invalidatesTags: (result, error) => {
				return error ? [] : [{ type: "users", id: "LIST" }];
			},
		}),
		sendEmail: build.query<void, string>({
			query: (email) => {
				return {
					url: `tasks/send-email?email=${email}`,
				};
			},
		}),
		updateUserStatus: build.mutation<void, Record<string, any>>({
			query: (body) => {
				return {
					url: `${url}/update-status`,
					method: "PUT",
					body
				};
			},
		}),
	}),
});
export const {
	useUpdateUserStatusMutation,
	useLazySendEmailQuery,
	useEditEmailUserMutation,
	useDeleteUserByIdMutation,
	useGetUserCountQuery,
	useLazyGetUsersQuery,
	useGetUsersQuery,
	useCreateUsersMutation,
	useUpdateUsersMutation,
	useDeleteUsersMutation,
} = userAPI;
